export const initializeProductEditState = ({
  styleCode,
  uniqueId,
  collectionId,
  status,
  name,
  descriptionLong,
  descriptionMaterials,
  department,
  category,
  subCategory,
  gender,
  images,
  quantityAvailable,
  items,
  currency,
  retailPrice,
  orderIndex,
  lines,
  subLines,
  groups,
  subGroups,
  keyStyles,
  keywords,
  recommendedItems,
  shippingStartDate,
  shippingEndDate,
  minQtyPerSize,
  minQtyPerStyle,
  country,
  hscode,
  isCarton,
  _id,
}) => ({
  styleCode,
  uniqueId,
  collectionId,
  status: status ? [status] : [],
  name,
  descriptionLong,
  descriptionMaterials,
  department: department ? [department] : [],
  category: category ? [category] : [],
  subCategory: subCategory ? [subCategory] : [],
  gender: gender ? [gender] : [],
  images,
  quantityAvailable,
  items,
  currency,
  retailPrice,
  orderIndex,
  lines,
  subLines,
  groups,
  subGroups,
  keyStyles,
  keywords,
  recommendedItems,
  shippingStartDate,
  shippingEndDate,
  minQtyPerSize,
  minQtyPerStyle,
  country: country ? [country] : [],
  hscode,
  isCarton,
  _id,
})
